const MIN_QUERY_LENGTH = 2;
const MAX_QUERY_LENGTH = 600;

export function validAssistantDeepLinkPrompt(value: string | null | undefined): string | null {
  const prompt = value?.trim();
  return prompt && prompt.length >= MIN_QUERY_LENGTH && prompt.length <= MAX_QUERY_LENGTH ? prompt : null;
}

export function assistantDeepLinkPath(query: string): string {
  return `/ai-assistant?q=${encodeURIComponent(query)}`;
}
